import { useDispatch } from 'react-redux';
import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { deleteDataSetFromList } from 'actions/RouteLogsActions';

type Props = {
  datasetID: string;
  onSubmitCallback?: () => void;
  onClose: () => void;
};

const DeleteModal = ({ datasetID, onSubmitCallback, onClose }: Props) => {
  const dispatch = useDispatch();
  const [response, setResponse] = React.useState({ text: '', status: '' });

  const onSubmit = async () => {
    try {
      const result = await dispatch(deleteDataSetFromList(datasetID));
      if ((result as any)?.code === 200)
        setResponse({ text: 'Success! The dataset has been deleted.', status: '200' });
      else throw new Error('There was a problem deleting the dataset. Please try again');
      onSubmitCallback && onSubmitCallback();
    } catch (err) {
      setResponse({
        text: `There was a problem deleting the dataset. Please try again. Error: ${
          (err as Error).message
        }`,
        status: '',
      });
    }
  };

  return (
    <>
      <Modal.Body>
        <p>Are you sure you want to delete this dataset? This action is permanant.</p>
        {response.text ? (
          <Alert variant={response.status === '200' ? 'success' : 'danger'}>{response.text}</Alert>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        {response.status === '200' ? (
          <Button variant="success" onClick={onClose}>
            Close
          </Button>
        ) : (
          <Button variant="danger" onClick={onSubmit}>
            Confirm
          </Button>
        )}
      </Modal.Footer>
    </>
  );
};

export default DeleteModal;
